module.exports = __webpack_public_path__ + "img/tela_computador_oferta.ce26f131.png";